import styled from "styled-components";

import { Link } from "@components/Navigation/Link";

export const MobileButton = styled(Link).attrs({
  as: "button",
  type: "button",
  $style: "medium_18",
})`
  ${props => props.theme.breakpointsV2.smallTablet} {
    display: none;
  }
`;

export const NonMobileButton = styled(Link).attrs({
  as: "button",
  type: "button",
  $style: {
    default: "medium_14",
    smallDesktop: "medium_18",
  },
})`
  display: none;

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: block;
  }
`;
